import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import AmountStatistics from './entity'
import Tree from "@/store/shared/entity/tree";

interface AmountStatisticsState extends ListStateItem<AmountStatistics>{
    editAmountStatistics:AmountStatistics,
}

class AmountStatisticsModule extends ListModuleItem<AmountStatisticsState,any,AmountStatistics>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editAmountStatistics:new AmountStatistics(),
    }
    actions={
        async getAll(context:ActionContext<AmountStatisticsState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/DeclareCustoms/GetAmountStatisticsElement',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<AmountStatistics>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
    };
    overrideMutations={
        edit(state:AmountStatisticsState,amountstatistics:AmountStatistics){
            state.editAmountStatistics=amountstatistics;
        }
    }
}
const amountStatisticsModule=new AmountStatisticsModule();
export default amountStatisticsModule;